import React, { useEffect, useState } from 'react';
import * as THREE from 'three';

const StageBackground = ({ image, realWidth, realHeight }) => {
    const [texture, setTexture] = useState(null);

    useEffect(() => {
        if (!image) return;

        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const scale = 4;
            const width = img.width * scale;
            const height = img.height * scale;
            const powerOfTwoWidth = Math.pow(2, Math.ceil(Math.log(width) / Math.log(2)));
            const powerOfTwoHeight = Math.pow(2, Math.ceil(Math.log(height) / Math.log(2)));

            canvas.width = powerOfTwoWidth;
            canvas.height = powerOfTwoHeight;

            context.drawImage(img, 0, 0, canvas.width, canvas.height);

            const loader = new THREE.TextureLoader();
            loader.load(
                canvas.toDataURL(),
                (tex) => {
                    tex.minFilter = THREE.LinearMipmapLinearFilter;
                    tex.magFilter = THREE.NearestFilter;
                    tex.anisotropy = 16;
                    tex.needsUpdate = true;
                    setTexture(tex);
                },
                undefined,
                (err) => console.log("Failed to load texture", err)
            );
        };
        img.src = image;
    }, [image]);

    if (!texture) return null;

    return (
        <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 0]}>
            <planeGeometry args={[realWidth, realHeight]} />
            <meshBasicMaterial map={texture} side={THREE.DoubleSide} />
        </mesh>
    );
};

export default StageBackground;